import { useEditContext, useGetOne, Loading, EditButton } from "react-admin";
import CallMergeIcon from "@mui/icons-material/CallMerge";
import Button from "@mui/material/Button";
import Divider from "@mui/material/Divider";
import Panel from "../../Components/Panel";

const ClientDuplicates = () => {
	const { record, isLoading } = useEditContext();
	const { id } = record || {};

	//Fetch duplicates for the current client
	const { data: duplicates, isLoading: isLoadingDuplicates } = useGetOne( `duplicates`, { id, meta: { returnRecords: true } } );

	if (isLoading || isLoadingDuplicates) return <Loading />;	

	console.log("Client Duplicates", duplicates);

	return (
		<>
			{ duplicates.clients?.data.length > 0 && <Panel title="Doublons">
				{duplicates.clients?.data?.map((duplicates) => {
							return duplicates.id !== record.id ? (
								<EditButton
									key={duplicates.id}
									resource="clients"
									label={
										duplicates.attributes.first_name +
										" " +
										duplicates.attributes.last_name
									}
									record={{ id: duplicates.id }}
									icon={null}
								/>
							) : null;
						})}
						<Divider sx={{ margin: "20px 0" }}/>
						<Button href={`/#/duplicates/${record.id}`} variant="contained" startIcon={ <CallMergeIcon /> } sx={{width: "100%"}}>Fusionner</Button>
			</Panel> }
		</>
	);
};

export default ClientDuplicates;
